import { styled } from '@mui/system';
import { SectionHeading, SectionSubtext, CtaWrapper } from '../../styles';
import { CTAButton as BaseCTAButton } from '../../../../../components/Header/styles';

export const BenefitsHeading = styled(SectionHeading)(({ theme }) => ({
  marginBottom: '14px',
  [theme.breakpoints.down('md')]: {
    marginBottom: '12px',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: '10px',
  },
}));

export const BenefitsSubtext = styled(SectionSubtext)(({ theme }) => ({
  fontWeight: 400,
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
}));

export const BenefitsCtaWrapper = styled(CtaWrapper)(({ theme }) => ({
  marginTop: '41px',
  [theme.breakpoints.down('md')]: {
    marginTop: '32px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '24px',
  },
}));

export const BenefitsCTAButton = styled(BaseCTAButton)(({ theme }) => ({
  padding: '20px 50px',
  margin: 0,
  minWidth: '297px',
  [theme.breakpoints.down('md')]: {
    padding: '16px 40px',
    minWidth: '260px',
    fontSize: '18px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '14px 30px',
    minWidth: '220px',
    fontSize: '16px',
    width: '100%',
    maxWidth: '297px',
  },
}));
